import { LocalizationHelper } from '../../shared/helpers/localization/localization.helper';
import { companyDe, companyEn, companyFr, companyIt } from './company/company.i18n';
import { C_Printed_Reports_Kind } from '../../graphql/generatedModel.ts';

type Keys =
  | 'options'
  | 'company'
  | 'configuration'
  | 'bakery2b'
  | 'general_tab'
  | 'customer_tab'
  | 'article_tab'
  | 'order_tab'
  | 'company_profile'
  | 'brand'
  | 'site'
  | 'profile_photo'
  | 'company_style'
  | 'menu_navigation_color'
  | 'background'
  | 'internet_orders_tab'
  | 'available_future_days'
  | 'minimal_order_value'
  | 'only_whole_numbers'
  | 'multiple_orders_allowed'
  | 'allow_zero_orders'
  | 'show_total_column_delivery_note'
  | 'email_for_order_notifications'
  | 'email_for_order_notifications_maxLen'
  | 'production_tab'
  | 'invoice_tab'
  | 'vat_tab'
  | 'use_new_site_version'
  | 'bank_accounts_tab'
  | 'post_tab'
  | 'financial_accounting_tab'
  | 'special_days_tab'
  | 'writing_tab'
  | 'client'
  | 'vat_normal'
  | 'vat_reduced'
  | 'no_vat'
  | 'activate_commit'
  | 'datev'
  | 'abacus'
  | 'actual_invoice_no'
  | 'rounding_total_prices'
  | 'use_another_countries'
  | 'euro_rate'
  | 'usd_rate'
  | 'enable_datev_export'
  | 'enable_xml_export'
  | 'configuration_saved'
  | 'configuration_not_saved'
  | 'assign_customer_no_automatically'
  | 'part_of_customer_no'
  | 'ongoing_value'
  | 'show_liters_in_production_print_lists'
  | 'can_close_orders_from_cashAssist'
  | 'take_into_consideration_own_produced_articles_from_procurement_in_backing_list_reports'
  | 'the_same_ean_code_may_be_assigned_to_several_articles'
  | 'show_shipping_points_in_articles'
  | 'shipping_function_activated'
  | 'vat_normal_rate'
  | 'vat_reduced_rate'
  | 'vat_special_1'
  | 'vat_special_2'
  | 'vat_zero'
  | 'product_groups_settings'
  | 'price_categories_settings'
  | 'delivery_note_groups_settings'
  | 'actual_order_number'
  | 'decimal_place_count'
  | 'order_position_sorting_kind'
  | 'kilo_amount_representation'
  | 'is_use_price_category_ahead'
  | 'is_got_next_delivery_day'
  | 'delivery_days'
  | 'related_directories'
  | 'article_list_settings'
  | 'customer_lists_settings'
  | 'post_sectors'
  | 'weight_up_to'
  | 'name'
  | 'profile_name'
  | 'cash_discount_in'
  | 'price_category'
  | 'summary_report'
  | 'payment_slip_report'
  | 'customer_groups_settings'
  | 'company_name_in_reports'
  | 'shipping_points_settings'
  | 'text_blocks_settings'
  | 'standard_order'
  | 'standard_offer'
  | 'standard_invoice'
  | 'text_block'
  | 'standard_besr'
  | 'standard_bank'
  | 'besr_format'
  | 'operation_cost_center'
  | 'tourplans_settings'
  | 'default_settings'
  | 'tourplan'
  | 'production_groups_settings'
  | 'marketing_groups_settings'
  | 'assortment_groups_settings'
  | 'quantity_discounts_settings'
  | 'quantity_discount'
  | 'banks_settings'
  | 'bank_settings'
  | 'internal_bank_description'
  | 'section_customer'
  | 'zip_code'
  | 'subscriber_num'
  | 'qr_iban'
  | 'customer_identification'
  | 'financial_accounting'
  | 'first_name'
  | 'second_name'
  | 'street'
  | 'recipe_book'
  | 'invalid_member_num'
  | 'invalid_qr_iban'
  | 'qr_field_hint'
  | 'customer_lists_one'
  | 'customer_lists_other'
  | 'customer_groups_one'
  | 'customer_groups_other'
  | 'delivery_note_groups_one'
  | 'delivery_note_groups_other'
  | 'tourplans_one'
  | 'tourplans_other'
  | 'article_list_one'
  | 'article_list_other'
  | 'product_groups_one'
  | 'product_groups_other'
  | 'production_groups_one'
  | 'production_groups_other'
  | 'assortment_groups_one'
  | 'assortment_groups_other'
  | 'marketing_groups_one'
  | 'marketing_groups_other'
  | 'price_categories_one'
  | 'price_categories_other'
  | 'shipping_points_one'
  | 'shipping_points_other'
  | 'quantity_discounts_one'
  | 'quantity_discounts_other'
  | 'post_sectors_one'
  | 'post_sectors_other'
  | 'post_sectors_settings'
  | 'text_blocks_one'
  | 'text_blocks_other'
  | 'section_bank'
  | 'cannot_delete_this_bank'
  | 'general_vat_system'
  | 'from_invoice_amount'
  | 'reminder_text'
  | 'reminder_texts_settings'
  | 'report_header'
  | 'fixed_shipping_costs'
  | 'shipping_costs_by_weight'
  | 'shipping_cost'
  | 'banks'
  | 'storage_locations_settings'
  | 'storage_locations_one'
  | 'storage_locations_other'
  | 'order_types_accounted_in_production_reports'
  | 'order_types'
  | 'working_with_versions'
  | 'production_printers_settings'
  | 'production_printers'
  | 'print_list_groups_settings'
  | 'print_list_groups_one'
  | 'print_list_groups_other'
  | 'import_tab'
  | 'mode'
  | 'some_existing_records_will_be_overwrited'
  | 'there_are_some_duplicates_in_import_data'
  | 'some_existing_record_will_be_overwrited'
  | 'duplicate_in_import_data'
  | 'import_successful'
  | 'special_prices_import'
  | 'special_prices_import_successful'
  | 'special_prices_periods'
  | 'special_prices_duplicate_periods'
  | 'special_prices_overlapping_periods'
  | 'special_prices_unknown_article'
  | 'special_prices_unknown_articles'
  | 'special_prices_unmapped_columns'
  | 'special_prices_mode_merge'
  | 'special_prices_mode_replace'
  | 'special_prices_replace_confirmation'
  | 'ai_processing_your_file'
  | 'automation'
  | 'automation_task'
  | 'automation_tasks'
  | 'create_automation_task'
  | 'delete_automation_task'
  | 'automation_type'
  | 'termination_orders_acceptance_hint'
  | 'termination_next_blocked_day'
  | 'active'
  | 'last'
  | 'next'
  | 'execution_timetable'
  | 'time'
  | 'weekDay'
  | 'monthDay'
  | 'month'
  | 'day'
  | 'client_other'
  | 'settings'
  | 'every'
  | 'in'
  | 'at'
  | 'files_export_directory'
  | 'toolbox_corrections_files_directory'
  | 'imported_toolbox_corrections_files_directory'
  | 'ordinal_ending'
  | 'ordinal_ending_1'
  | 'ordinal_ending_2'
  | 'ordinal_ending_3'
  | 'execute'
  | 'task_started'
  | 'ftp_connection'
  | 'host'
  | 'port'
  | 'remote_path'
  | 'days_before_after_execution_date'
  | 'special_dates_settings'
  | 'replacing_date'
  | 'activate_ftp'
  | 'reimport_articles_from_ca'
  | 'message_to_fix_article_numbers'
  | 'duplicates_were_found'
  | 'ca_number'
  | 'ca_description'
  | 'searching_for_duplicate_articles'
  | 'scanning_articles_in_cashassist_and_wawiassist'
  | 'comparing_data_between_systems'
  | 'checking_article_uniqueness'
  | 'finalizing_duplicate_search'
  | 'article_import_title'
  | 'article_import_created'
  | 'article_import_updated'
  | 'subtitle_import_step_2'
  | 'import_saving_mapping'
  | 'import_starting'
  | 'import_processing_rows'
  | 'import_validating_data'
  | 'import_applying_changes'
  | 'printers_assignment'
  | 'form_printing_assignment'
  | 'invite_new_client'
  | 'client_details'
  | 'add_new_articles'
  | 'order_no_delivery_on_this_day'
  | 'order_show_price_total'
  | 'standard_order_edit'
  | 'more_settings'
  | 'left_symbols'
  | 'deactivate_message'
  | 'deactivate_confirmation'
  | 'connected_customers'
  | 'invitation_reminder'
  | 'deactivate_client'
  | 'activate_client'
  | 'delete_client'
  | 'deactivation_failed'
  | 'activation_failed'
  | 'deactivated_success'
  | 'activated_success'
  | 'invitation_sent'
  | 'statistic'
  | 'orders_from_new_bakery2b'
  | 'orders_in_period'
  | 'orders_from_beginning'
  | 'export_environment'
  | 'use_tour_setting_for_every_order'
  | C_Printed_Reports_Kind // todo here because it has duplicates in the general enum translation file
  | reportConfiguration
  | 'view_all_edit'
  | 'no_preview_offer_not_exist_sub'
  | 'no_preview_order_not_exist_sub'
  | 'no_preview_invoice_not_exist_sub'
  | 'no_preview_customer_not_exist_sub'
  | 'use_standard_text'
  | 'email_text'
  | 'edit_wawi_orders'
  | 'one_time_customer_settings'
  | 'default_profile_one_time_customers';

type reportConfiguration =
  | 'reportConfigurationTab'
  | 'print_form_type'
  | 'print_form_article_pricelist'
  | 'print_form_offer'
  | 'print_form_delivery_note_a4'
  | 'print_form_delivery_note_a5'
  | 'print_form_invoice'
  | 'print_form_payment_slip'
  | 'print_form_debt_reminder'
  | 'no_preview_article_not_exist'
  | 'no_preview_offer_not_exist'
  | 'no_preview_order_not_exist'
  | 'no_preview_invoice_not_exist'
  | 'page_margins'
  | 'page_background_image'
  | 'letterhead'
  | 'custom_text'
  | 'customer_address'
  | 'delivery_address'
  | 'invoice_address'
  | 'invoice_address_on_2_plus_pages'
  | 'delete_reason'
  | 'bank_information'
  | 'phone_number'
  | 'picture'
  | 'logo'
  | 'reset_to_default'
  | 'logo_on_1_page'
  | 'logo_on_2_plus_pages'
  | 'company_vat_no'
  | 'image_in_footer'
  | 'footerText'
  | 'printed_at_in_footer'
  | 'page_numbering_in_footer'
  | 'created_by_in_footer'
  | 'visible'
  | 'cm_brackets'
  | 'size'
  | 'left_margin'
  | 'top_margin'
  | 'bottom_margin'
  | 'left'
  | 'top'
  | 'height'
  | 'width'
  | 'expand_preview'
  | 'general_settings_for_all_print_forms'
  | 'apply_logo_to_all_print_forms'
  | 'apply_letterhead_to_all_print_forms'
  | 'apply_footerText_to_all_print_forms'
  | 'apply_settings_for_all_print_forms_warning'
  | 'import_mapping'
  | 'cashassist_price_categories'
  | 'wawiassist_price_categories';

const t = LocalizationHelper<Keys>('settings');

export const settingsDe = t({
  orders_from_new_bakery2b: 'Bestellungen von neuer bakery2b',
  orders_in_period: 'Bestellungen im Zeitraum',
  orders_from_beginning: 'Bestellungen von Anfang an',
  statistic: 'Statistik',
  invitation_sent: 'Die Einladung wurde {{email}} gesendet',
  deactivation_failed: 'Deaktivierung fehlgeschlagen',
  activation_failed: 'Aktivierung fehlgeschlagen',
  deactivated_success: 'Erfolgreich deaktiviert',
  activated_success: 'Erfolgreich aktiviert',
  deactivate_client: 'Kunde deaktivieren',
  activate_client: 'Kunde aktivieren',
  delete_client: 'Kunde löschen',
  connected_customers: 'Verbundene Kunden',
  invitation_reminder: 'Einladungserinnerung',
  deactivate_confirmation: 'Möchten Sie diesen Kunden wirklich deaktivieren?',
  deactivate_message: 'Dieser Kunde wurde deaktiviert.',
  left_symbols: 'Übrig',
  more_settings: 'Mehr Einstellungen',
  add_new_articles: 'Neue Produkte hinzufügen',
  order_no_delivery_on_this_day: 'Bestellung: Keine Lieferung an diesem Tag',
  order_show_price_total: 'Bestellung: Preis / Summe anzeigen',
  standard_order_edit: 'Standardbestellung: Bearbeiten',
  client_details: 'Kundendetails',
  invite_new_client: 'Neuen Kunden einladen',
  form_printing_assignment: 'Formulardruck-Zuweisung',
  printers_assignment: 'Druckerzuweisung',
  bakery2b: 'Bakery2b',
  available_future_days: 'Bestellhorizont (Tage)',
  company_profile: 'Firmenprofil',
  brand: 'Marke',
  site: 'Webseite',
  profile_photo: 'Profilfoto (200x200)',
  company_style: 'Firmenstil',
  menu_navigation_color: 'Farbe für die Menünavigation',
  background: 'Hintergrund (800x1600)',
  minimal_order_value: 'Mindestbestellwert (in Währung)',
  only_whole_numbers: 'Nur ganze Zahlen in Bestellungen erlauben',
  multiple_orders_allowed: 'Mehrere Bestellungen am Tag erlauben',
  allow_zero_orders: 'Null-Total möglich',
  show_total_column_delivery_note: 'Spalte Total im Lieferscheinbereich anzeigen',
  email_for_order_notifications: 'E-Mail für Bestellbenachrichtigungen',
  email_for_order_notifications_maxLen: 'Maximale Zeichenanzahl - 1000',
  use_new_site_version:
    'Neue Website-Version verwenden (Benutzer von bakery2b.com zu new.bakery2b.com umleiten)',
  client_other: 'Kunden',
  settings: 'Einstellungen',
  import_saving_mapping: 'Feldzuordnung wird gespeichert…',
  import_starting: 'Import wird vorbereitet…',
  import_processing_rows: 'Daten werden importiert, bitte warten…',
  import_validating_data: 'Daten werden überprüft…',
  import_applying_changes: 'Import wird abgeschlossen…',
  subtitle_import_step_2:
    'Weisen Sie die CashAssist Preiskategorien den ensprechenden WawiAssist Kategorien und klicken Sie anschließend auf "Importieren".',
  cashassist_price_categories: 'CashAssist-Preiskategorien',
  wawiassist_price_categories: 'WaWiAssist-Preiskategorien',
  import_mapping: 'Import-Zuordnung',
  article_import_title: 'Artikelimport abgeschlossen.',
  article_import_created: '{{count}} erstellt',
  article_import_updated: '{{count}} aktualisiert',
  searching_for_duplicate_articles: 'Suche nach doppelten Artikeln wird durchgeführt…',
  scanning_articles_in_cashassist_and_wawiassist:
    'Artikel in CashAssist und WawiAssist werden gescannt…',
  comparing_data_between_systems: 'Datenvergleich zwischen den Systemen…',
  checking_article_uniqueness: 'Überprüfung der Artikel auf Eindeutigkeit…',
  finalizing_duplicate_search: 'Abschluss der Dublettensuche…',
  ca_description: 'CashAssist-Beschreibung',
  ca_number: 'CashAssist-Nummer',
  duplicates_were_found: 'Duplikate wurden gefunden.',
  message_to_fix_article_numbers:
    'Um fortzufahren, korrigieren Sie bitte die folgenden Artikelnummern.',
  activate_ftp: 'FTP aktivieren',
  reimport_articles_from_ca: 'Artikel aus CA importieren',
  remote_path: 'Remote-Pfad',
  port: 'Port',
  host: 'Host',
  ftp_connection: 'FTP-Verbindung',
  days_before_after_execution_date: 'Tage vor/nach dem Ausführungsdatum',
  apply_footerText_to_all_print_forms: 'Fußzeilentext auf alle Druckformulare anwenden',
  apply_letterhead_to_all_print_forms: 'Briefkopf auf alle Druckformulare anwenden',
  apply_logo_to_all_print_forms: 'Logo auf alle Druckformulare anwenden',
  options: 'Optionen',
  company: companyDe,
  configuration: 'Konfiguration',
  imported_toolbox_corrections_files_directory:
    'Verzeichnis der importierten Toolbox-Korrekturdateien',
  toolbox_corrections_files_directory: 'Verzeichnis der Toolbox-Korrekturdateien',
  general_tab: 'Allgemein',
  customer_tab: 'Kunde',
  article_tab: 'Artikel',
  reset_to_default: 'Auf Standard zurücksetzen',
  order_tab: 'Bestellung',
  internet_orders_tab: 'Internet Bestellung',
  production_tab: 'Produktion',
  invoice_tab: 'Rechnung',
  vat_tab: 'Mwst',
  bank_accounts_tab: 'Bankkonto',
  post_tab: 'Post',
  financial_accounting_tab: 'Fibu',
  special_days_tab: 'Besondere tage',
  writing_tab: 'Schrift',
  client: 'Mandant',
  vat_normal: 'MwSt normaler',
  vat_reduced: 'MwSt reduziert',
  no_vat: 'Keine MwSt',
  activate_commit: 'Festschreibung aktivieren',
  datev: 'Datev',
  profile_name: 'Profilname',
  cash_discount_in: 'Skonto in %',
  price_category: 'Preiskategorie',
  summary_report: 'Zusammenzug Formular',
  payment_slip_report: 'Einzahlungsschein Formular',
  default_settings: 'Standardeinstellungen',
  abacus: 'Abacus',
  size: 'Größe',
  production_groups_one: 'Produktionsgruppe',
  production_groups_other: 'Produktionsgruppen',
  production_groups_settings: 'Produktionsgruppen Einstellungen',
  shipping_points_one: 'Versandstellen',
  shipping_points_other: 'Versandstelle',
  shipping_points_settings: 'Versandstellen Einstellungen',
  actual_invoice_no: 'Aktuell Rechnung-Nr.',
  rounding_total_prices: 'Total Preisrundung',
  use_another_countries: 'Eine andere Währung verwenden',
  euro_rate: 'Euro-Kurs',
  usd_rate: 'USD-Kurs',
  enable_datev_export: 'Datev-Export aktivieren',
  enable_xml_export: 'XML-Export aktivieren',
  configuration_saved: 'Konfiguration wurde erfolgreich gespeichert',
  configuration_not_saved: 'Fehler: Konfiguration nicht gespeichert!',
  assign_customer_no_automatically: 'Kunden-Nr. automatisch vergeben',
  part_of_customer_no: 'Teil der Kunden-Nr.',
  ongoing_value: 'Fortlaufender Wert',
  show_liters_in_production_print_lists: 'Produktionslisten mit Liter anzeigen',
  can_close_orders_from_cashAssist: 'Bestellnahme vom CashAssist schließen',
  take_into_consideration_own_produced_articles_from_procurement_in_backing_list_reports:
    'Eigenproduzierte Artikel aus der Beschaffung in Backzettel berücksichtigen',
  the_same_ean_code_may_be_assigned_to_several_articles:
    'Derselbe EAN code darf mehreren Artikeln vergeben werden',
  show_shipping_points_in_articles: 'Versandstellen in Artikeln anzeigen',
  shipping_function_activated: 'Aktivieren Post Function',
  vat_normal_rate: 'MwSt Normalsatz',
  vat_reduced_rate: 'MwSt reduzierter Satz',
  vat_special_1: 'MwSt spezial 1',
  vat_special_2: 'MwSt spezial 2',
  vat_zero: 'MwSt 0%',
  product_groups_settings: 'Warengruppen Einstellungen',
  product_groups_one: 'Warengruppe',
  product_groups_other: 'Warengruppen',
  price_categories_settings: 'Preiskategorien Einstellungen',
  actual_order_number: 'Aktuell Lieferschein-Nr.',
  decimal_place_count: 'Anzahl der Dezimalstellen',
  order_position_sorting_kind: 'Bestellung positionen sortieren nach',
  kilo_amount_representation: 'Darstellung der Kilogrammmenge',
  is_use_price_category_ahead: 'Wenn kein Preis, vorgehende Preiskategorie',
  is_got_next_delivery_day:
    'Bei der Erfassung der Bestellung, automatisch auf den nächsten Liefertag positionieren',
  delivery_days: 'Liefertage',
  related_directories: 'Verwandte Verzeichnisse',
  delivery_note_groups_settings: 'Lieferscheingruppen Einstellungen',
  delivery_note_groups_one: 'Lieferscheingruppe',
  delivery_note_groups_other: 'Lieferscheingruppen',
  article_list_settings: 'Artikellisten Einstellungen',
  article_list_one: 'Artikelliste',
  article_list_other: 'Artikellisten',
  customer_lists_settings: 'Kundenlisten Einstellungen',
  customer_lists_one: 'Kundenliste',
  customer_lists_other: 'Kundenlisten',
  post_sectors_settings: 'Transportsektoren Einstellungen',
  post_sectors: 'Transportsektoren',
  post_sectors_one: 'Transportsektor',
  post_sectors_other: 'Transportsektoren',
  weight_up_to: 'Gewicht bis (g)',
  name: 'Name',
  customer_groups_settings: 'Kundengruppen Einstellungen',
  customer_groups_one: 'Kundengruppe',
  customer_groups_other: 'Kundengruppen',
  text_blocks_settings: 'Textbausteine Einstellungen',
  text_blocks_one: 'Textbaustein',
  text_blocks_other: 'Textbausteine',
  standard_order: 'Standard (Bestellen)',
  standard_offer: 'Standard (Angebot)',
  standard_invoice: 'Standard (Rechnung)',
  text_block: 'Textbaustein',
  company_name_in_reports: 'Firmenname auf Drucklisten',
  standard_besr: 'Standard BESR',
  standard_bank: 'Standard Bank',
  besr_format: ' BESR Format',
  operation_cost_center: 'Betrieb Kostenstelle',
  marketing_groups_settings: 'Marketing-Gruppe Einstellungen',
  tourplans_settings: 'Tourenplanen Einstellungen',
  tourplans_one: 'Tourenplane',
  tourplans_other: 'Tourenplanen',
  tourplan: 'Touren',
  assortment_groups_one: 'Sortimentsgruppe',
  assortment_groups_other: 'Sortimentsgruppen',
  assortment_groups_settings: 'Sortimentsgruppen Einstellungen',
  quantity_discounts_settings: 'Mengenrabatt Einstellungen',
  quantity_discounts_one: 'Mengenrabatt',
  quantity_discounts_other: 'Mengenrabatt',
  quantity_discount: 'Mengenrabatt',
  marketing_groups_one: 'Marketing-Gruppe',
  marketing_groups_other: 'Marketing-Gruppe',
  price_categories_one: 'Preiskategorie',
  price_categories_other: 'Preiskategorien',
  banks_settings: 'Banken Einstellungen',
  bank_settings: 'Bank Einstellungen',
  internal_bank_description: 'Interne Bankbezeichnung',
  section_bank: 'Bank',
  section_customer: 'Kunde',
  zip_code: 'PLZ',
  subscriber_num: 'ESR/BESR Teilnehmer-Nr.',
  qr_iban: 'QR-IBAN',
  customer_identification: 'Kundenidentifikation (max. 6 Stellen)',
  financial_accounting: 'FIBU-Konto',
  first_name: 'Name 1',
  second_name: 'Name 2',
  street: 'Strasse',
  recipe_book: 'Verbuchung der Zahlungseingänge',
  invalid_member_num: 'Es sind nur Zahlen erlaubt',
  invalid_qr_iban: 'Die eingegebene IBAN ist keine QR-IBAN.',
  qr_field_hint:
    'Dieses Feld ist erforderlich, um den QR-Code auf der QR-Rechnung korrekt zu erstellen',
  cannot_delete_this_bank:
    'Sie können diese Bank leider nicht löschen, da sie als Standardbank definiert ist.',
  general_vat_system: 'Algemeines MwSt-System',
  from_invoice_amount: 'Ab Rechnungsbetrag',
  reminder_text: 'Mahnungstext',
  reminder_texts_settings: 'Mahnungstexten Einstellungen',
  fixed_shipping_costs: 'Feste Versandkosten',
  shipping_costs_by_weight: 'Versandkosten nach Gewicht',
  shipping_cost: 'Versandkosten',
  report_header: 'Berichtskopf',
  banks: 'Banken',
  storage_locations_settings: 'Lagerorte Einstellungen',
  storage_locations_one: 'Lagerort',
  storage_locations_other: 'Lagerorte',
  order_types_accounted_in_production_reports:
    'Bestelltypen mit Einfluss auf die Produktionslisten',
  order_types: 'Bestelltypen',
  working_with_versions: 'Mit Versionen arbeiten',
  import_tab: 'Import',
  mode: 'Modus',
  some_existing_records_will_be_overwrited:
    'Einige vorhandene Datensätze werden durch neue importierte Datensätze überschrieben',
  there_are_some_duplicates_in_import_data: 'Es gibt einige Duplikate in den Importdaten',
  some_existing_record_will_be_overwrited:
    'Ein bestehender Datensatz wird durch einen neuen importierten Datensatz überschrieben',
  duplicate_in_import_data: 'Doppelter Eintrag in den Importdaten',
  import_successful:
    'Import erfolgreich.\nEingefügte Datensätze: {{recordsInserted}}.\nAktualisierte Datensätze:{{recordsUpdated}}.',
  special_prices_import: 'Spezialpreise',
  special_prices_import_successful:
    'Import der Spezialpreise erfolgreich.\nEingefügte Perioden: {{recordsInserted}}.\nAktualisierte Perioden: {{recordsUpdated}}.\nÜbersprungene Zeilen: {{recordsSkipped}}.',
  special_prices_periods: 'Perioden: {{selected}} von {{total}} gewählt ({{articles}} Artikel)',
  special_prices_duplicate_periods:
    'Dieselbe Periode kommt mehrfach vor. Importiert wird nur die letzte Zeile.',
  special_prices_overlapping_periods:
    'Einige Perioden überschneiden sich. Es gilt die Periode mit dem späteren Datum "Gültig ab".',
  special_prices_unknown_article: 'Artikelnummer existiert nicht',
  special_prices_unknown_articles:
    '{{total}} Zeile(n) mit unbekannter Artikelnummer werden übersprungen. Artikel werden beim Preisimport nicht angelegt.',
  special_prices_unmapped_columns:
    'Diese Preisspalten konnten keiner Preiskategorie zugeordnet werden und werden ignoriert: {{columns}}',
  special_prices_mode_merge: 'Perioden zusammenführen',
  special_prices_mode_replace: 'Tabelle pro Artikel ersetzen',
  special_prices_replace_confirmation:
    'Alle bestehenden Spezialpreis-Perioden von {{articles}} Artikel(n) werden gelöscht und durch die Zeilen aus der Datei ersetzt. Perioden, die nicht in der Datei stehen, gehen verloren.',
  ai_processing_your_file: 'HS-Soft AI verarbeitet Ihre Datei...',
  production_printers_settings: 'Produktionsdrucker Einstellungen',
  production_printers: 'Produktionsdrucker',
  print_list_groups_settings: 'Drucklisten Gruppen Einstellungen',
  print_list_groups_one: 'Drucklisten Gruppe',
  print_list_groups_other: 'Drucklisten Gruppen',
  reportConfigurationTab: 'Berichteinstellungen',
  print_form_type: 'Druckformulartyp',
  print_form_article_pricelist: 'Artikelpreisliste',
  print_form_offer: 'Angebot',
  print_form_delivery_note_a4: 'Lieferschein A4',
  print_form_delivery_note_a5: 'Lieferschein A5',
  print_form_invoice: 'Faktura',
  print_form_payment_slip: 'Einzahlungsschein',
  print_form_debt_reminder: 'Mahnung',
  no_preview_article_not_exist:
    'Berichtsvorschau nicht verfügbar. Bitte erstellen Sie zuerst einen <a>Artikel</a>',
  no_preview_offer_not_exist:
    'Berichtsvorschau nicht verfügbar. Bitte erstellen Sie zuerst ein <a>Angebot</a>',
  no_preview_order_not_exist:
    'Berichtsvorschau nicht verfügbar. Bitte erstellen Sie zuerst einen <a>Bestellung</a>',
  no_preview_invoice_not_exist:
    'Berichtsvorschau nicht verfügbar. Bitte erstellen Sie zuerst einen <a>Faktura</a>',
  page_margins: 'Seitenränder',
  page_background_image: 'Hintergrundbild der Seite',
  letterhead: 'Briefkopf',
  custom_text: 'Individueller Text',
  customer_address: 'Kundenadresse',
  delivery_address: 'Lieferadresse',
  invoice_address: 'Rechnungsadresse',
  invoice_address_on_2_plus_pages: 'Rechnungsadresse auf 2+ Seiten',
  delete_reason: 'Löschen Grund',
  bank_information: 'Bankverbindung',
  phone_number: 'Telefonnummer',
  picture: 'Bild',
  logo: 'Logo',
  logo_on_1_page: 'Logo auf 1 Seite',
  logo_on_2_plus_pages: 'Logo auf 2+ Seiten',
  company_vat_no: 'Unternehmens-USt-IdNr.',
  image_in_footer: 'Bild im Fußbereich',
  footerText: 'Text im Fußbereich',
  printed_at_in_footer: 'Gedruckt am (Fußbereich)',
  page_numbering_in_footer: 'Seitenzahlen (Fußbereich)',
  created_by_in_footer: 'Erstellt von (Fußbereich)',
  visible: 'Sichtbar',
  cm_brackets: '(cm)',
  left_margin: 'Linker',
  top_margin: 'Oberer',
  bottom_margin: 'Unterer',
  left: 'Links',
  top: 'Oben',
  height: 'Höhe',
  width: 'Breite',
  automation: 'Automatisierung',
  automation_task: 'Automatisierung',
  automation_tasks: 'Automatisierungen',
  create_automation_task: 'Automatisierung erstellen',
  delete_automation_task: 'Automatisierung löschen',
  automation_type: 'Automatisierungstyp',
  termination_orders_acceptance_hint:
    'Die Ausführung sperrt das Erfassen und Bearbeiten von Bestellungen (bakery2b.com und CashAssist DirectAccess) nach Lieferdatum: Kurz nach Mitternacht geplant (z. B. 00:01), sperrt sie Bestellungen für denselben Tag; im Laufe des Tages geplant, sperrt sie Bestellungen für den Folgetag.',
  termination_next_blocked_day: 'Nächster gesperrter Tag',
  expand_preview: 'Vorschau erweitern',
  last: 'Letzte',
  next: 'Nächste',
  active: 'Aktiv',
  execution_timetable: 'Ausführungs-Zeitplan',
  time: 'Startzeit',
  weekDay: 'Wochentag',
  monthDay: 'Monat Tag',
  month: 'Monat',
  every: 'Jeden',
  day: 'Tag',
  in: 'im',
  at: 'um',
  ordinal_ending: '.',
  ordinal_ending_1: '.',
  ordinal_ending_2: '.',
  ordinal_ending_3: '.',
  files_export_directory: 'Ordner für den Datei-Export',
  execute: 'Ausführen',
  task_started: 'Die Aufgabe wurde gestartet.',
  general_settings_for_all_print_forms: 'Auf alle Druckformulare anwenden',
  apply_settings_for_all_print_forms_warning:
    'Einige Druckformulare enthalten bereits ein benutzerdefiniertes "{{field}}". Die Anwendung dieses Werts wird ihn ersetzen.',
  special_dates_settings: 'Sondertermine Einstellungen',
  replacing_date: 'Datum ersetzen',
  [C_Printed_Reports_Kind.BAKING_LISTS]: 'Productionslisten',
  [C_Printed_Reports_Kind.CROSSTABLE_REPORTS]: 'Kreuzberichte',
  [C_Printed_Reports_Kind.DELIVERY_NOTES_A4]: 'Lieferscheine A4',
  [C_Printed_Reports_Kind.DELIVERY_NOTES_A5]: 'Lieferscheine A5',
  [C_Printed_Reports_Kind.FORWARDING_LISTS]: 'Speditionlisten',
  [C_Printed_Reports_Kind.INVOICES]: 'Rechnungen',
  [C_Printed_Reports_Kind.INVOICE_PAYMENT_SLIP]: 'Einzahlungsschein zu Rechnung',
  [C_Printed_Reports_Kind.INVOICE_SUMMARY]: 'Zusammenzug zu Rechnung',
  [C_Printed_Reports_Kind.OFFERS]: 'Angebote',
  export_environment: 'Exportumgebung',
  use_tour_setting_for_every_order: 'Tour-Einstellung für jede Bestellung verwenden',
  view_all_edit: 'Alles anzeigen & bearbeiten',
  no_preview_offer_not_exist_sub:
    'Berichtsvorschau nicht verfügbar. Bitte erstellen Sie zuerst ein <a>Angebot</a> für das ausgewählte Unternehmen',
  no_preview_order_not_exist_sub:
    'Berichtsvorschau nicht verfügbar. Bitte erstellen Sie zuerst eine <a>Bestellung</a> für das ausgewählte Unternehmen',
  no_preview_invoice_not_exist_sub:
    'Berichtsvorschau nicht verfügbar. Bitte erstellen Sie zuerst eine <a>Faktura</a> für das ausgewählte Unternehmen',
  no_preview_customer_not_exist_sub:
    'Diesem Unternehmen ist noch kein Kunde zugewiesen – daher sind aktuell keine Informationen verfügbar.',
  use_standard_text: 'Verwenden Sie Standardtext',
  email_text: 'E-Mail Text',
  edit_wawi_orders: 'WaWi-Bestellungen bearbeiten',
  one_time_customer_settings: 'Einmalkunden-Einstellungen',
  default_profile_one_time_customers: 'Standardprofil für Einmalkunden',
});

export const settingsFr = t({
  orders_from_new_bakery2b: 'Commandes de la nouvelle bakery2b',
  orders_in_period: 'Commandes dans la période',
  orders_from_beginning: 'Commandes depuis le début',
  statistic: 'Statistique',
  invitation_sent: "L'invitation a été envoyée à {{email}}",
  deactivation_failed: 'Échec de la désactivation',
  activation_failed: 'Échec de l’activation',
  deactivated_success: 'Désactivé avec succès',
  activated_success: 'Activé avec succès',
  deactivate_client: 'Désactiver le client',
  activate_client: 'Activer le client',
  delete_client: 'Supprimer le client',
  connected_customers: 'Clients connectés',
  invitation_reminder: "Rappel d'invitation",
  deactivate_confirmation: 'Êtes-vous sûr de vouloir désactiver ce client?',
  deactivate_message: 'Ce client a été désactivé.',
  left_symbols: 'Restant',
  more_settings: 'Plus de paramètres',
  add_new_articles: 'Ajouter de nouveaux articles',
  order_no_delivery_on_this_day: "Commande: Pas de livraison aujourd'hui",
  order_show_price_total: 'Commande: Afficher prix/total',
  standard_order_edit: 'Commande standard: Modifier',
  client_details: 'Détails du client',
  invite_new_client: 'Inviter un nouveau client',
  form_printing_assignment: 'Affectation d’impression de formulaire',
  printers_assignment: 'Affectation des imprimantes',
  bakery2b: 'Bakery2B',
  company_profile: 'Profil de l’entreprise',
  brand: 'Marque',
  site: 'Site',
  profile_photo: 'Photo de profil (200x200)',
  company_style: 'Style de l’entreprise',
  menu_navigation_color: 'Couleur pour le menu de navigation',
  background: 'Arrière-plan (800x1600)',
  available_future_days: 'Jours futurs disponibles',
  minimal_order_value: 'Valeur minimale de commande (en devise)',
  only_whole_numbers: 'Nombres entiers uniquement dans les commandes',
  multiple_orders_allowed: 'L’utilisateur peut passer plus d’une commande par jour',
  allow_zero_orders: 'Autoriser les commandes à zéro',
  show_total_column_delivery_note:
    'Afficher la colonne « Total » dans le tableau du bon de livraison',
  email_for_order_notifications: 'E-mail pour les notifications de commande',
  email_for_order_notifications_maxLen: 'Nombre maximum de caractères - 1000',
  use_new_site_version:
    'Utiliser la nouvelle version du site (rediriger les utilisateurs de bakery2b.com vers new.bakery2b.com)',
  client_other: 'Clients',
  settings: 'Paramètres',
  import_saving_mapping: 'Enregistrement du mapping des champs…',
  import_starting: 'Préparation de l’importation…',
  import_processing_rows: 'Importation en cours, veuillez patienter…',
  import_validating_data: 'Vérification des données…',
  import_applying_changes: 'Finalisation de l’importation…',
  subtitle_import_step_2:
    'Assignez les catégories de prix de WaWiAssist aux catégories correspondantes dans CashAssist, puis cliquez sur «Importer».',
  cashassist_price_categories: 'Catégories de prix CashAssist',
  wawiassist_price_categories: 'Catégories de prix WaWiAssist',
  import_mapping: 'Correspondance d’importation',
  article_import_title: 'Importation des articles terminée.',
  article_import_created: '{{count}} créés',
  article_import_updated: '{{count}} mis à jour',
  searching_for_duplicate_articles: 'Recherche des doublons d’articles en cours…',
  scanning_articles_in_cashassist_and_wawiassist:
    'Analyse des articles dans CashAssist et WawiAssist…',
  comparing_data_between_systems: 'Comparaison des données entre les systèmes…',
  checking_article_uniqueness: 'Vérification de l’unicité des articles…',
  finalizing_duplicate_search: 'Finalisation de la recherche des doublons…',
  ca_number: 'Numéro CashAssist',
  ca_description: 'Description CashAssist',
  duplicates_were_found: 'Des doublons ont été trouvés.',
  message_to_fix_article_numbers:
    'Pour continuer, veuillez corriger les numéros d’article suivants.',
  activate_ftp: 'Activer FTP',
  reimport_articles_from_ca: 'Réimporter les articles depuis CA',
  remote_path: 'Chemin distant',
  port: 'Port',
  host: 'Hôte',
  ftp_connection: 'Connexion FTP',
  days_before_after_execution_date: 'Jours avant/après la date d’exécution',
  apply_footerText_to_all_print_forms:
    'Appliquer le texte de pied de page à tous les formulaires d’impression',
  apply_letterhead_to_all_print_forms: 'Appliquer l’en-tête à tous les formulaires d’impression',
  apply_logo_to_all_print_forms: 'Appliquer le logo à tous les formulaires d’impression',
  options: 'Options',
  company: companyFr,
  configuration: 'Configuration',
  imported_toolbox_corrections_files_directory:
    'Répertoire des fichiers de corrections importés de la boîte à outils',
  toolbox_corrections_files_directory:
    'Répertoire des fichiers de corrections de la boîte à outils',
  general_tab: 'Général',
  customer_tab: 'Client',
  reset_to_default: 'Réinitialiser par défaut',
  article_tab: 'Article',
  order_tab: 'Commande',
  internet_orders_tab: 'Commandes internet',
  production_tab: 'Production',
  invoice_tab: 'Facture',
  vat_tab: 'TVA',
  default_settings: 'Paramètres par défaut',
  bank_accounts_tab: 'Compte bancaire',
  post_tab: 'Poste',
  financial_accounting_tab: 'Comptabilité financière',
  special_days_tab: 'Jours spéciaux',
  writing_tab: 'Écriture',
  client: 'Client',
  vat_normal: 'TVA normale',
  vat_reduced: 'TVA réduite',
  no_vat: 'Sans TVA',
  activate_commit: 'Activer la validation',
  datev: 'Datev',
  size: 'Taille',
  abacus: 'Abacus',
  profile_name: 'Nom du profil',
  cash_discount_in: 'Remise en espèces en %',
  price_category: 'Catégorie de prix',
  summary_report: 'Rapport récapitulatif',
  payment_slip_report: 'Rapport de bulletin de versement',
  actual_invoice_no: 'N° de facture actuel',
  rounding_total_prices: 'Arrondi des prix totaux',
  use_another_countries: 'Utiliser d’autres devises',
  euro_rate: 'Taux de l’euro',
  usd_rate: 'Taux de l’USD',
  production_groups_one: 'Groupe de production',
  production_groups_other: 'Groupes de production',
  production_groups_settings: 'Paramètres des groupes de production',
  shipping_points_one: 'Point de livraison',
  shipping_points_other: 'Points de livraison',
  shipping_points_settings: 'Paramètres des points de livraison',
  enable_datev_export: 'Activer l’export Datev',
  enable_xml_export: 'Activer l’export XML',
  configuration_saved: 'Configuration enregistrée avec succès',
  configuration_not_saved: 'Erreur : Configuration non enregistrée!',
  assign_customer_no_automatically: 'Attribuer le n° client automatiquement',
  part_of_customer_no: 'Partie du n° client',
  ongoing_value: 'Valeur en cours',
  show_liters_in_production_print_lists: 'Afficher les litres dans les listes de production',
  can_close_orders_from_cashAssist: 'Peut clôturer les commandes depuis CashAssist',
  take_into_consideration_own_produced_articles_from_procurement_in_backing_list_reports:
    'Prendre en compte les articles produits en interne dans les rapports de liste de production',
  the_same_ean_code_may_be_assigned_to_several_articles:
    'Le même code EAN peut être attribué à plusieurs articles',
  show_shipping_points_in_articles: 'Afficher les points de livraison dans les articles',
  shipping_function_activated: 'Activer la fonction d’expédition',
  vat_normal_rate: 'Taux normal de TVA',
  vat_reduced_rate: 'Taux réduit de TVA',
  vat_special_1: 'TVA spéciale 1',
  vat_special_2: 'TVA spéciale 2',
  vat_zero: 'TVA 0%',
  product_groups_settings: 'Paramètres des groupes de produits',
  product_groups_one: 'Groupe de produit',
  product_groups_other: 'Groupes de produits',
  price_categories_settings: 'Paramètres des catégories de prix',
  actual_order_number: 'N° de commande actuel',
  decimal_place_count: 'Nombre de décimales',
  order_position_sorting_kind: 'Trier les positions de commande par',
  kilo_amount_representation: 'Représentation de la quantité en kilogrammes',
  is_use_price_category_ahead: 'Si pas de prix, utiliser la catégorie de prix par défaut',
  is_got_next_delivery_day:
    'Passer automatiquement au prochain jour de livraison lors de la saisie de la commande',
  delivery_days: 'Jours de livraison',
  related_directories: 'Répertoires associés',
  delivery_note_groups_settings: 'Paramètres des groupes de bons de livraison',
  delivery_note_groups_one: 'Groupe de bons de livraison',
  delivery_note_groups_other: 'Groupes de bons de livraison',
  article_list_settings: 'Paramètres des listes d’articles',
  article_list_one: 'Liste d’articles',
  article_list_other: 'Listes d’articles',
  customer_lists_settings: 'Paramètres des listes de clients',
  customer_lists_one: 'Liste de clients',
  customer_lists_other: 'Listes de clients',
  post_sectors_settings: 'Paramètres des secteurs postaux',
  post_sectors: 'Secteurs postaux',
  post_sectors_one: 'Secteur postal',
  post_sectors_other: 'Secteurs postaux',
  weight_up_to: 'Poids jusqu’à (g)',
  name: 'Nom',
  customer_groups_settings: 'Paramètres des groupes de clients',
  customer_groups_one: 'Groupe de clients',
  customer_groups_other: 'Groupes de clients',
  text_blocks_settings: 'Paramètres des blocs de texte',
  text_blocks_one: 'Bloc de texte',
  text_blocks_other: 'Blocs de texte',
  standard_order: 'Standard (Commande)',
  standard_offer: 'Standard (Offre)',
  standard_invoice: 'Standard (Facture)',
  text_block: 'Bloc de texte',
  company_name_in_reports: 'Nom de l’entreprise sur les listes d’impression',
  standard_besr: 'BESR standard',
  standard_bank: 'Banque standard',
  besr_format: 'Format BESR',
  operation_cost_center: 'Centre de coûts d’opération',
  tourplans_settings: 'Paramètres des plans de tournée',
  tourplans_one: 'Plan de tournée',
  tourplans_other: 'Plans de tournée',
  tourplan: 'Plan de tournée',
  marketing_groups_settings: 'Paramètres des groupes marketing',
  assortment_groups_one: 'Groupe d’assortiment',
  assortment_groups_other: 'Groupes d’assortiment',
  assortment_groups_settings: 'Paramètres des groupes d’assortiment',
  quantity_discounts_settings: 'Paramètres des remises sur quantité',
  quantity_discounts_one: 'Remise sur quantité',
  quantity_discounts_other: 'Remises sur quantité',
  quantity_discount: 'Remise sur quantité',
  marketing_groups_one: 'Groupe marketing',
  marketing_groups_other: 'Groupes marketing',
  price_categories_one: 'Catégorie de prix',
  price_categories_other: 'Catégories de prix',
  banks_settings: 'Paramètres des banques',
  bank_settings: 'Paramètres bancaires',
  internal_bank_description: 'Description interne de la banque',
  section_bank: 'Banque',
  section_customer: 'Client',
  zip_code: 'Code postal / Localité',
  subscriber_num: 'N° d’abonné ESR/BESR',
  qr_iban: 'QR-IBAN',
  customer_identification: 'Identification du client (max. 6 lettres)',
  financial_accounting: 'Compte bancaire de comptabilité financière',
  first_name: 'Prénom',
  second_name: 'Nom 2',
  street: 'Rue',
  recipe_book: 'Livre des recettes',
  invalid_member_num: 'Seuls les chiffres sont autorisés',
  invalid_qr_iban: 'L’IBAN que vous avez saisi n’est pas un QR IBAN.',
  qr_field_hint: 'Ce champ est utilisé pour générer le code QR sur le bulletin de versement QR.',
  cannot_delete_this_bank:
    'Malheureusement, vous ne pouvez pas supprimer cette banque car elle est définie comme banque par défaut.',
  general_vat_system: 'Système général de TVA',
  from_invoice_amount: 'À partir du montant (facture)',
  reminder_text: 'Texte de rappel',
  reminder_texts_settings: 'Paramètres des textes de rappel',
  fixed_shipping_costs: 'Frais de port fixes',
  shipping_costs_by_weight: 'Frais de port selon le poids',
  shipping_cost: 'Frais de port',
  report_header: 'En-tête de rapport',
  banks: 'Banques',
  storage_locations_settings: 'Paramètres des emplacements de stockage',
  storage_locations_one: 'Emplacement de stockage',
  storage_locations_other: 'Emplacements de stockage',
  order_types_accounted_in_production_reports:
    'Types de commandes inclus dans les rapports de production',
  order_types: 'Types de commandes',
  working_with_versions: 'Travailler avec les versions',
  import_tab: 'Importer',
  mode: 'Mode',
  some_existing_records_will_be_overwrited:
    'Certains enregistrements existants seront écrasés par les nouveaux enregistrements importés',
  there_are_some_duplicates_in_import_data: 'Il y a des doublons dans les données d’importation',
  some_existing_record_will_be_overwrited:
    'Un enregistrement existant sera écrasé par un nouveau enregistrement importé',
  duplicate_in_import_data: 'Doublon dans les données d’importation',
  import_successful:
    'Importation réussie.\nEnregistrements insérés: {{recordsInserted}}.\nEnregistrements mis à jour:{{recordsUpdated}}.',
  special_prices_import: 'Prix spéciaux',
  special_prices_import_successful:
    'Importation des prix spéciaux réussie.\nPériodes insérées: {{recordsInserted}}.\nPériodes mises à jour: {{recordsUpdated}}.\nLignes ignorées: {{recordsSkipped}}.',
  special_prices_periods:
    'Périodes: {{selected}} sur {{total}} sélectionnées ({{articles}} articles)',
  special_prices_duplicate_periods:
    'La même période apparaît plusieurs fois. Seule la dernière ligne sera importée.',
  special_prices_overlapping_periods:
    'Certaines périodes se chevauchent. La période avec la date "Valable dès" la plus récente s’applique.',
  special_prices_unknown_article: 'Le numéro d’article n’existe pas',
  special_prices_unknown_articles:
    '{{total}} ligne(s) avec un numéro d’article inconnu seront ignorées. L’importation des prix ne crée pas d’articles.',
  special_prices_unmapped_columns:
    'Ces colonnes de prix n’ont pu être associées à aucune catégorie de prix et seront ignorées: {{columns}}',
  special_prices_mode_merge: 'Fusionner les périodes',
  special_prices_mode_replace: 'Remplacer le tableau par article',
  special_prices_replace_confirmation:
    'Toutes les périodes de prix spéciaux existantes de {{articles}} article(s) seront supprimées et remplacées par les lignes du fichier. Les périodes absentes du fichier seront perdues.',
  ai_processing_your_file: 'L’IA HS-Soft traite votre fichier...',
  production_printers_settings: 'Paramètres des imprimantes de production',
  production_printers: 'Imprimantes de production',
  print_list_groups_settings: 'Paramètres des groupes de listes d’impression',
  print_list_groups_one: 'Groupe de listes d’impression',
  print_list_groups_other: 'Groupes de listes d’impression',
  reportConfigurationTab: 'Configuration du rapport',
  print_form_type: "Type de formulaire d'impression",
  print_form_article_pricelist: 'Liste de prix des articles',
  print_form_offer: 'Offre',
  print_form_delivery_note_a4: 'Bon de livraison A4',
  print_form_delivery_note_a5: 'Bon de livraison A5',
  print_form_invoice: 'Facture',
  print_form_payment_slip: 'Bordereau de paiement',
  print_form_debt_reminder: 'Rappel',
  no_preview_article_not_exist:
    "Aperçu du rapport non disponible. Veuillez d'abord créer un <a>article</a>",
  no_preview_offer_not_exist:
    "Aperçu du rapport non disponible. Veuillez d'abord créer une <a>offre</a>.",
  no_preview_order_not_exist:
    "Aperçu du rapport non disponible. Veuillez d'abord créer une <a>commande</a>",
  no_preview_invoice_not_exist:
    "Aperçu du rapport non disponible. Veuillez d'abord créer une <a>facture</a>",
  page_margins: 'Marges de page',
  page_background_image: 'Image de fond de page',
  letterhead: 'En-tête',
  custom_text: 'Texte individuel',
  customer_address: 'Adresse du client',
  delivery_address: 'Adresse de livraison',
  invoice_address: 'Adresse de facturation',
  invoice_address_on_2_plus_pages: 'Adresse de facturation sur 2+ pages',
  delete_reason: 'Raison de la suppression',
  bank_information: 'Informations bancaires',
  phone_number: 'Numéro de téléphone',
  picture: 'Image',
  logo: 'Logo',
  logo_on_1_page: 'Logo sur 1 page',
  logo_on_2_plus_pages: 'Logo sur 2+ pages',
  company_vat_no: "Numéro de TVA (UID) de l'entreprise",
  image_in_footer: 'Image dans le pied de page',
  footerText: 'Texte dans le pied de page',
  printed_at_in_footer: 'Imprimé le (pied de page)',
  page_numbering_in_footer: 'Numérotation des pages (pied de page)',
  created_by_in_footer: 'Créé par (pied de page)',
  visible: 'Visible',
  cm_brackets: '(cm)',
  left_margin: 'Gauche',
  top_margin: 'Supérieure',
  bottom_margin: 'Inférieure',
  left: 'Gauche',
  top: 'Haut',
  height: 'Hauteur',
  width: 'Largeur',
  automation: 'Automation',
  automation_task: 'Automation',
  automation_tasks: 'Automatismes',
  create_automation_task: 'Créer une automation',
  delete_automation_task: `Supprimer l'automatisation`,
  automation_type: `Type d'automatisation`,
  termination_orders_acceptance_hint:
    "L'exécution bloque la saisie et la modification des commandes (bakery2b.com et CashAssist DirectAccess) selon la date de livraison : planifiée juste après minuit (p. ex. 00:01), elle bloque les commandes de ce même jour ; planifiée en cours de journée, elle bloque les commandes du lendemain.",
  termination_next_blocked_day: 'Prochain jour bloqué',
  expand_preview: 'Développer l’aperçu',
  last: 'Dernier',
  next: 'Suivant',
  active: 'Actif',
  execution_timetable: `Calendrier d'exécution`,
  time: 'Heure de début',
  weekDay: 'Jour de la semaine',
  monthDay: 'Jour du mois',
  month: 'Mois',
  every: 'Chaque',
  at: 'á',
  day: 'jour',
  in: 'dans',
  ordinal_ending: 'e',
  ordinal_ending_1: 'er',
  ordinal_ending_2: 'e',
  ordinal_ending_3: 'e',
  files_export_directory: 'Dossier d’exportation des fichiers',
  execute: 'Exécuter',
  task_started: 'La tâche a démarré.',
  general_settings_for_all_print_forms: "Appliquer à tous les formulaires d'impression",
  apply_settings_for_all_print_forms_warning:
    'Certains formulaires d\'impression ont déjà un "{{field}}" personnalisé. Son application le remplacera.',
  special_dates_settings: 'Paramètres des dates spéciales',
  replacing_date: 'Date de remplacement',
  [C_Printed_Reports_Kind.BAKING_LISTS]: 'Liste de cuisson',
  [C_Printed_Reports_Kind.CROSSTABLE_REPORTS]: 'Rapport croisé',
  [C_Printed_Reports_Kind.DELIVERY_NOTES_A4]: 'Bons de livraison A4',
  [C_Printed_Reports_Kind.DELIVERY_NOTES_A5]: 'Bons de livraison A5',
  [C_Printed_Reports_Kind.FORWARDING_LISTS]: 'Listes de transmission',
  [C_Printed_Reports_Kind.INVOICES]: 'Factures',
  [C_Printed_Reports_Kind.INVOICE_PAYMENT_SLIP]: 'Bulletin de paiement pour facture',
  [C_Printed_Reports_Kind.INVOICE_SUMMARY]: 'Résumé de facture',
  [C_Printed_Reports_Kind.OFFERS]: 'Offres',
  export_environment: 'Environnement d’exportation',
  use_tour_setting_for_every_order: 'Utiliser le paramètre de tournée pour chaque commande',
  view_all_edit: 'Afficher tout et modifier',
  no_preview_offer_not_exist_sub:
    "Aperçu du rapport non disponible. Veuillez d'abord créer une <a>offre</a> pour l’entreprise sélectionnée.",
  no_preview_order_not_exist_sub:
    "Aperçu du rapport non disponible. Veuillez d'abord créer une <a>commande</a> pour l’entreprise sélectionnée.",
  no_preview_invoice_not_exist_sub:
    "Aperçu du rapport non disponible. Veuillez d'abord créer une <a>facture</a> pour l’entreprise sélectionnée.",
  no_preview_customer_not_exist_sub:
    'Aucun client n’est encore attribué à cette <a>entreprise</a> – aucune information n’est disponible pour le moment.',
  use_standard_text: 'Utiliser le texte standard',
  email_text: 'Texte de l’e-mail',
  edit_wawi_orders: 'Modifier les commandes WaWi',
  one_time_customer_settings: 'Paramètres client ponctuel',
  default_profile_one_time_customers: 'Profil par défaut pour clients ponctuels',
});

export const settingsIt = t({
  orders_from_new_bakery2b: 'Ordini dalla nuova bakery2b',
  orders_in_period: 'Ordini nel periodo',
  orders_from_beginning: "Ordini dall'inizio",
  statistic: 'Statistica',
  invitation_sent: "L'invito è stato inviato a {{email}}",
  deactivation_failed: 'Disattivazione non riuscita',
  activation_failed: 'Attivazione non riuscita',
  deactivated_success: 'Disattivato con successo',
  activated_success: 'Attivato con successo',
  deactivate_client: 'Disattiva cliente',
  activate_client: 'Attiva cliente',
  delete_client: 'Elimina cliente',
  connected_customers: 'Clienti collegati',
  invitation_reminder: 'Promemoria invito',
  deactivate_confirmation: 'Sei sicuro di voler disattivare questo cliente?',
  deactivate_message: 'Questo cliente è stato disattivato.',
  left_symbols: 'Rimasti',
  more_settings: 'Altre impostazioni',
  add_new_articles: 'Aggiungi nuovi articoli',
  order_no_delivery_on_this_day: 'Ordine: Nessuna consegna in questo giorno',
  order_show_price_total: 'Ordine: Mostra prezzo/totale',
  standard_order_edit: 'Ordine standard: Modifica',
  client_details: 'Dettagli cliente',
  invite_new_client: 'Invita un nuovo cliente',
  form_printing_assignment: 'Assegnazione di stampa modulo',
  printers_assignment: 'Assegnazione stampanti',
  bakery2b: 'Bakery2B',
  company_profile: 'Profilo aziendale',
  brand: 'Marchio',
  site: 'Sito',
  profile_photo: 'Foto profilo (200x200)',
  company_style: 'Stile aziendale',
  menu_navigation_color: 'Colore per il menu di navigazione',
  background: 'Sfondo (800x1600)',
  available_future_days: 'Giorni futuri disponibili',
  minimal_order_value: 'Valore minimo dell’ordine (in valuta)',
  only_whole_numbers: 'Solo numeri interi negli ordini',
  multiple_orders_allowed: 'L’utente può effettuare più di un ordine al giorno',
  allow_zero_orders: 'Consentire ordini a zero',
  show_total_column_delivery_note:
    'Mostra la colonna «Totale» nella sezione della bolla di consegna',
  email_for_order_notifications: 'E-mail per le notifiche degli ordini',
  email_for_order_notifications_maxLen: 'Numero massimo di caratteri - 1000',
  use_new_site_version:
    'Usa la nuova versione del sito (reindirizza gli utenti da bakery2b.com a new.bakery2b.com)',
  client_other: 'Clienti',
  settings: 'Impostazioni',
  import_saving_mapping: 'Salvataggio della mappatura dei campi…',
  import_starting: 'Preparazione all’importazione dei dati…',
  import_processing_rows: 'Importazione in corso, attendere prego…',
  import_validating_data: 'Controllo dei dati…',
  import_applying_changes: 'Completamento dell’importazione…',
  subtitle_import_step_2:
    'Assegna le categorie di prezzo da WaWiAssist alle categorie corrispondenti in CashAssist, quindi fai clic su "Importa".',
  cashassist_price_categories: 'Categorie di prezzo CashAssist',
  wawiassist_price_categories: 'Categorie di prezzo WaWiAssist',
  import_mapping: 'Mappatura di importazione',
  article_import_title: 'Importazione degli articoli completata.',
  article_import_created: '{{count}} creati',
  article_import_updated: '{{count}} aggiornati',
  searching_for_duplicate_articles: 'Ricerca di articoli duplicati in corso…',
  scanning_articles_in_cashassist_and_wawiassist:
    'Scansione degli articoli in CashAssist e WawiAssist…',
  comparing_data_between_systems: 'Confronto dei dati tra i sistemi…',
  checking_article_uniqueness: 'Verifica dell’unicità degli articoli…',
  finalizing_duplicate_search: 'Completamento della ricerca di duplicati…',
  ca_description: 'Descrizione CashAssist',
  ca_number: 'Numero CashAssist',
  duplicates_were_found: 'Sono stati trovati dei duplicati.',
  message_to_fix_article_numbers: 'Per continuare, correggi i seguenti numeri di articolo.',
  activate_ftp: 'Attivare FTP',
  reimport_articles_from_ca: 'Reimporta gli articoli da CA',
  remote_path: 'Percorso remoto',
  port: 'Porta',
  host: 'Host',
  ftp_connection: 'Connessione FTP',
  days_before_after_execution_date: 'Giorni prima/dopo la data di esecuzione',
  apply_footerText_to_all_print_forms:
    'Applica il testo a piè di pagina a tutti i moduli di stampa',
  apply_letterhead_to_all_print_forms: 'Applica l’intestazione a tutti i moduli di stampa',
  apply_logo_to_all_print_forms: 'Applica il logo a tutti i moduli di stampa',
  options: 'Opzioni',
  company: companyIt,
  configuration: 'Configurazione',
  general_tab: 'Generale',
  customer_tab: 'Cliente',
  imported_toolbox_corrections_files_directory:
    'Directory dei file di correzione importati della Toolbox',
  toolbox_corrections_files_directory: 'Directory dei file di correzione della Toolbox',
  article_tab: 'Articolo',
  order_tab: 'Ordine',
  internet_orders_tab: 'Ordini online',
  production_tab: 'Produzione',
  invoice_tab: 'Fattura',
  vat_tab: 'IVA',
  size: 'Dimensione',
  reset_to_default: 'Ripristina impostazioni predefinite',
  default_settings: 'Impostazioni predefinite',
  bank_accounts_tab: 'Conto bancario',
  post_tab: 'Posta',
  financial_accounting_tab: 'Contabilità finanziaria',
  special_days_tab: 'Giorni speciali',
  writing_tab: 'Scrittura',
  client: 'Cliente',
  vat_normal: 'IVA normale',
  vat_reduced: 'IVA ridotta',
  no_vat: 'Senza IVA',
  activate_commit: 'Attivare il commit',
  datev: 'Datev',
  abacus: 'Abacus',
  profile_name: 'Nome del profilo',
  cash_discount_in: 'Sconto cassa in %',
  price_category: 'Categoria di prezzo',
  summary_report: 'Rapporto riepilogativo',
  payment_slip_report: 'Rapporto bollettino di pagamento',
  actual_invoice_no: 'N. fattura attuale',
  rounding_total_prices: 'Arrotondamento prezzi totali',
  use_another_countries: 'Usa altre valute',
  euro_rate: 'Tasso euro',
  usd_rate: 'Tasso USD',
  production_groups_one: 'Gruppo di produzione',
  production_groups_other: 'Gruppi di produzione',
  production_groups_settings: 'Impostazioni gruppi di produzione',
  shipping_points_one: 'Punto di spedizione',
  shipping_points_other: 'Punti di spedizione',
  shipping_points_settings: 'Impostazioni punti di spedizione',
  enable_datev_export: 'Abilitare esportazione Datev',
  enable_xml_export: 'Abilitare esportazione XML',
  configuration_saved: 'Configurazione salvata con successo',
  configuration_not_saved: 'Errore: configurazione non salvata!',
  assign_customer_no_automatically: 'Assegna N. cliente automaticamente',
  part_of_customer_no: 'Parte del N. cliente',
  ongoing_value: 'Valore corrente',
  show_liters_in_production_print_lists: 'Mostra litri nelle liste di produzione',
  can_close_orders_from_cashAssist: 'Può chiudere ordini da CashAssist',
  take_into_consideration_own_produced_articles_from_procurement_in_backing_list_reports:
    'Considera articoli prodotti in proprio dalla fornitura nei rapporti di produzione',
  the_same_ean_code_may_be_assigned_to_several_articles:
    'Lo stesso codice EAN può essere assegnato a più articoli',
  show_shipping_points_in_articles: 'Mostra punti di spedizione negli articoli',
  shipping_function_activated: 'Funzione di spedizione attivata',
  vat_normal_rate: 'Aliquota IVA normale',
  vat_reduced_rate: 'Aliquota IVA ridotta',
  vat_special_1: 'IVA speciale 1',
  vat_special_2: 'IVA speciale 2',
  vat_zero: 'IVA 0%',
  product_groups_settings: 'Impostazioni gruppi di prodotti',
  product_groups_one: 'Gruppo di prodotti',
  product_groups_other: 'Gruppi di prodotti',
  price_categories_settings: 'Impostazioni categorie di prezzo',
  actual_order_number: 'N. ordine attuale',
  decimal_place_count: 'Numero di decimali',
  order_position_sorting_kind: 'Ordina le posizioni degli ordini per',
  kilo_amount_representation: 'Rappresentazione in chilogrammi',
  is_use_price_category_ahead: "Se non c'è prezzo, usa categoria di prezzo precedente",
  is_got_next_delivery_day:
    "All'acquisizione dell'ordine, passa automaticamente al giorno di consegna successivo",
  delivery_days: 'Giorni di consegna',
  related_directories: 'Directory correlate',
  delivery_note_groups_settings: 'Impostazioni gruppi note di consegna',
  delivery_note_groups_one: 'Gruppo note di consegna',
  delivery_note_groups_other: 'Gruppi note di consegna',
  article_list_settings: 'Impostazioni liste articoli',
  article_list_one: 'Lista articoli',
  article_list_other: 'Liste articoli',
  customer_lists_settings: 'Impostazioni liste clienti',
  customer_lists_one: 'Lista clienti',
  customer_lists_other: 'Liste clienti',
  post_sectors_settings: 'Impostazioni settori postali',
  post_sectors: 'Settori postali',
  post_sectors_one: 'Settore postale',
  post_sectors_other: 'Settori postali',
  weight_up_to: 'Peso fino a (g)',
  name: 'Nome',
  customer_groups_settings: 'Impostazioni gruppi clienti',
  customer_groups_one: 'Gruppo clienti',
  customer_groups_other: 'Gruppi clienti',
  text_blocks_settings: 'Impostazioni blocchi di testo',
  text_blocks_one: 'Blocco di testo',
  text_blocks_other: 'Blocchi di testo',
  standard_order: 'Standard (Ordine)',
  standard_offer: 'Standard (Offerta)',
  standard_invoice: 'Standard (Fattura)',
  text_block: 'Blocco di testo',
  company_name_in_reports: 'Nome azienda sulle liste di stampa',
  standard_besr: 'Standard BESR',
  standard_bank: 'Banca standard',
  besr_format: 'Formato BESR',
  operation_cost_center: 'Centro di costo operativo',
  tourplans_settings: 'Impostazioni piani di tour',
  tourplans_one: 'Piano di tour',
  tourplans_other: 'Piani di tour',
  tourplan: 'Piano di tour',
  marketing_groups_settings: 'Impostazioni gruppi di marketing',
  assortment_groups_one: 'Gruppo assortimenti',
  assortment_groups_other: 'Gruppi assortimenti',
  assortment_groups_settings: 'Impostazioni gruppi assortimenti',
  quantity_discounts_settings: 'Impostazioni sconti quantità',
  quantity_discounts_one: 'Sconto quantità',
  quantity_discounts_other: 'Sconti quantità',
  quantity_discount: 'Sconto quantità',
  marketing_groups_one: 'Gruppo marketing',
  marketing_groups_other: 'Gruppi marketing',
  price_categories_one: 'Categoria di prezzo',
  price_categories_other: 'Categorie di prezzo',
  banks_settings: 'Impostazioni banche',
  bank_settings: 'Impostazioni banca',
  internal_bank_description: 'Descrizione banca interna',
  section_bank: 'Banca',
  section_customer: 'Cliente',
  zip_code: 'CAP/Località',
  subscriber_num: 'N. abbonato ESR/BESR',
  qr_iban: 'QR-IBAN',
  customer_identification: 'Identificazione cliente (max. 6 lettere)',
  financial_accounting: 'Conto bancario contabilità finanziaria',
  first_name: 'Nome 1',
  second_name: 'Nome 2',
  street: 'Via',
  recipe_book: 'Libro delle ricevute',
  invalid_member_num: 'Sono ammessi solo numeri',
  invalid_qr_iban: "L'IBAN inserito non è un QR IBAN.",
  qr_field_hint:
    'Questo campo è utilizzato per generare il codice QR sulla polizza di versamento QR.',
  cannot_delete_this_bank:
    'Non è possibile eliminare questa banca poiché è definita come banca predefinita.',
  general_vat_system: 'Sistema IVA generale',
  from_invoice_amount: 'Da importo (fattura)',
  reminder_text: 'Testo promemoria',
  reminder_texts_settings: 'Impostazioni testi promemoria',
  fixed_shipping_costs: 'Costi di spedizione fissi',
  shipping_costs_by_weight: 'Costi di spedizione in base al peso',
  shipping_cost: 'Costo di spedizione',
  report_header: 'Intestazione rapporto',
  banks: 'Banche',
  storage_locations_settings: 'Impostazioni ubicazioni di stoccaggio',
  storage_locations_one: 'Ubicazione di stoccaggio',
  storage_locations_other: 'Ubicazioni di stoccaggio',
  order_types_accounted_in_production_reports:
    'Tipi di ordine conteggiati nei rapporti di produzione',
  order_types: 'Tipi di ordine',
  working_with_versions: 'Lavorare con le versioni',
  import_tab: 'Importa',
  mode: 'Modalità',
  some_existing_records_will_be_overwrited:
    'Alcuni record esistenti saranno sovrascritti con i nuovi record importati',
  there_are_some_duplicates_in_import_data:
    'Sono presenti alcune duplicazioni nei dati di importazione',
  some_existing_record_will_be_overwrited:
    'Un record esistente verrà sovrascritto con un nuovo record importato',
  duplicate_in_import_data: 'Duplicato nei dati di importazione',
  import_successful:
    'Importazione riuscita.\nRecord inseriti: {{recordsInserted}}.\nRecord aggiornati:{{recordsUpdated}}.',
  special_prices_import: 'Prezzi speciali',
  special_prices_import_successful:
    'Importazione dei prezzi speciali riuscita.\nPeriodi inseriti: {{recordsInserted}}.\nPeriodi aggiornati: {{recordsUpdated}}.\nRighe ignorate: {{recordsSkipped}}.',
  special_prices_periods: 'Periodi: {{selected}} di {{total}} selezionati ({{articles}} articoli)',
  special_prices_duplicate_periods:
    'Lo stesso periodo è presente più volte. Verrà importata solo l’ultima riga.',
  special_prices_overlapping_periods:
    'Alcuni periodi si sovrappongono. Vale il periodo con la data "Valido dal" più recente.',
  special_prices_unknown_article: 'Il codice articolo non esiste',
  special_prices_unknown_articles:
    '{{total}} riga/righe con codice articolo sconosciuto verranno ignorate. L’importazione dei prezzi non crea articoli.',
  special_prices_unmapped_columns:
    'Queste colonne di prezzo non corrispondono a nessuna categoria di prezzo e verranno ignorate: {{columns}}',
  special_prices_mode_merge: 'Unisci i periodi',
  special_prices_mode_replace: 'Sostituisci la tabella per articolo',
  special_prices_replace_confirmation:
    'Tutti i periodi di prezzo speciale esistenti di {{articles}} articolo/i verranno eliminati e sostituiti dalle righe del file. I periodi non presenti nel file andranno persi.',
  ai_processing_your_file: 'L’intelligenza artificiale di HS-Soft elabora il tuo file...',
  production_printers_settings: 'Impostazioni stampanti di produzione',
  production_printers: 'Stampanti di produzione',
  print_list_groups_settings: 'Impostazioni gruppi di elenchi di stampa',
  print_list_groups_one: 'Gruppo di elenchi di stampa',
  print_list_groups_other: 'Gruppi di elenchi di stampa',
  reportConfigurationTab: 'Configurazione del rapporto',
  print_form_type: 'Tipo di modulo di stampa',
  print_form_article_pricelist: 'Listino prezzi articoli',
  print_form_offer: 'Offerta',
  print_form_delivery_note_a4: 'Bolla di consegna A4',
  print_form_delivery_note_a5: 'Bolla di consegna A5',
  print_form_invoice: 'Fattura',
  print_form_payment_slip: 'Bollettino di pagamento',
  print_form_debt_reminder: 'Sollecito',
  no_preview_article_not_exist:
    'Anteprima del rapporto non disponibile. Si prega di creare prima un <a>articolo</a>',
  no_preview_offer_not_exist:
    'Anteprima del rapporto non disponibile. Si prega di creare prima un <a>offerta</a>.',
  no_preview_order_not_exist:
    'Anteprima del rapporto non disponibile. Si prega di creare prima un <a>ordine</a>',
  no_preview_invoice_not_exist:
    'Anteprima del rapporto non disponibile. Si prega di creare prima un <a>fattura</a>',
  page_margins: 'Margini della pagina',
  page_background_image: 'Immagine di sfondo della pagina',
  letterhead: 'Intestazione',
  custom_text: 'Testo individuale',
  customer_address: 'Indirizzo del cliente',
  delivery_address: 'Indirizzo di consegna',
  invoice_address: 'Indirizzo di fatturazione',
  invoice_address_on_2_plus_pages: 'Indirizzo di fatturazione su 2+ pagine',
  delete_reason: "Motivo dell'eliminazione",
  bank_information: 'Informazioni bancarie',
  phone_number: 'Numero di telefono',
  picture: 'Immagine',
  logo: 'Logo',
  logo_on_1_page: 'Logo su 1 pagina',
  logo_on_2_plus_pages: 'Logo su 2+ pagine',
  company_vat_no: "Numero di partita IVA (UID) dell'azienda",
  image_in_footer: 'Immagine nel piè di pagina',
  footerText: 'Testo nel piè di pagina',
  printed_at_in_footer: 'Stampato il (piè di pagina)',
  page_numbering_in_footer: 'Numerazione delle pagine (piè di pagina)',
  created_by_in_footer: 'Creato da (piè di pagina)',
  visible: 'Visibile',
  cm_brackets: '(cm)',
  left_margin: 'Sinistro',
  top_margin: 'Superiore',
  bottom_margin: 'Inferiore',
  left: 'Sinistra',
  top: 'Sopra',
  height: 'Altezza',
  width: 'Larghezza',
  expand_preview: 'Espandi l’anteprima',
  automation: 'Automazione',
  automation_task: 'Automazione',
  create_automation_task: 'Crea automazione',
  automation_tasks: 'Automazioni',
  delete_automation_task: 'Elimina automazione',
  automation_type: 'Tipo di automazione',
  termination_orders_acceptance_hint:
    "L'esecuzione blocca l'inserimento e la modifica degli ordini (bakery2b.com e CashAssist DirectAccess) in base alla data di consegna: pianificata subito dopo mezzanotte (ad es. 00:01), blocca gli ordini dello stesso giorno; pianificata durante la giornata, blocca gli ordini del giorno successivo.",
  termination_next_blocked_day: 'Prossimo giorno bloccato',
  next: 'Prossimo',
  last: 'Scorso',
  active: 'Attivo',
  execution_timetable: 'Calendario di esecuzione',
  time: 'Ora di inizio',
  weekDay: 'Giorno della settimana',
  monthDay: 'Giorno del mese',
  month: 'Mese',
  day: 'giorno',
  every: 'Ogni',
  in: 'di',
  at: 'alle',
  ordinal_ending: '°',
  ordinal_ending_1: '°',
  ordinal_ending_2: '°',
  ordinal_ending_3: '°',
  files_export_directory: 'Cartella di esportazione dei file',
  execute: 'Esegui',
  task_started: 'L’attività è iniziata.',
  general_settings_for_all_print_forms: 'Applica a tutti i moduli di stampa',
  apply_settings_for_all_print_forms_warning:
    'Alcuni moduli di stampa hanno già un "{{field}}" personalizzato. Applicandolo, verrà sostituito.',
  special_dates_settings: 'Impostazioni date speciali',
  replacing_date: 'Sostituzione della data',
  [C_Printed_Reports_Kind.BAKING_LISTS]: 'Lista di cottura',
  [C_Printed_Reports_Kind.CROSSTABLE_REPORTS]: 'Rapporto a tabella incrociata',
  [C_Printed_Reports_Kind.DELIVERY_NOTES_A4]: 'Bolle di consegna A4',
  [C_Printed_Reports_Kind.DELIVERY_NOTES_A5]: 'Bolle di consegna A5',
  [C_Printed_Reports_Kind.FORWARDING_LISTS]: 'Liste di inoltro',
  [C_Printed_Reports_Kind.INVOICES]: 'Fatture',
  [C_Printed_Reports_Kind.INVOICE_PAYMENT_SLIP]: 'Bollettino di pagamento per fattura',
  [C_Printed_Reports_Kind.INVOICE_SUMMARY]: 'Riepilogo fattura',
  [C_Printed_Reports_Kind.OFFERS]: 'Offerte',
  export_environment: 'Ambiente di esportazione',
  use_tour_setting_for_every_order: 'Utilizza l’impostazione del giro di consegna per ogni ordine',
  view_all_edit: 'Mostra tutto e modifica',
  no_preview_offer_not_exist_sub:
    'Anteprima del rapporto non disponibile. Si prega di creare prima un’<a>offerta</a> per l’azienda selezionata.',
  no_preview_order_not_exist_sub:
    'Anteprima del rapporto non disponibile. Si prega di creare prima un <a>ordine</a> per l’azienda selezionata.',
  no_preview_invoice_not_exist_sub:
    'Anteprima del rapporto non disponibile. Si prega di creare prima una <a>fattura</a> per l’azienda selezionata.',
  no_preview_customer_not_exist_sub:
    'A questa azienda non è ancora assegnato alcun <a>cliente</a> – al momento non sono disponibili informazioni.',
  use_standard_text: 'Usa il testo standard',
  email_text: "Testo dell'e-mail",
  edit_wawi_orders: 'Modifica ordini WaWi',
  one_time_customer_settings: 'Impostazioni cliente occasionale',
  default_profile_one_time_customers: 'Profilo predefinito per clienti occasionali',
});

export const settingsEn = t({
  orders_from_new_bakery2b: 'Orders from new bakery2b',
  orders_in_period: 'Orders in period',
  orders_from_beginning: 'Orders from beginning',
  statistic: 'Statistic',
  invitation_sent: 'The invitation was sent to {{email}}',
  deactivation_failed: 'Deactivation failed',
  activation_failed: 'Activation failed',
  deactivated_success: 'Successfully deactivated',
  activated_success: 'Successfully activated',
  deactivate_client: 'Deactivate client',
  activate_client: 'Activate client',
  delete_client: 'Delete client',
  invitation_reminder: 'Invitation reminder',
  connected_customers: 'Connected customers',
  deactivate_confirmation: 'Are you sure you want to deactivate this client?',
  deactivate_message: 'This client has been deactivated.',
  left_symbols: 'Left',
  more_settings: 'More settings',
  add_new_articles: 'Add new articles',
  order_no_delivery_on_this_day: 'Order: No Delivery on this day',
  order_show_price_total: 'Order: Show Price/Total',
  standard_order_edit: 'Standard Order: Edit',
  client_details: 'Client details',
  invite_new_client: 'Invite new client',
  form_printing_assignment: 'Form printing assignment',
  printers_assignment: 'Printers assignment',
  import_saving_mapping: 'Saving your field mapping…',
  import_starting: 'Preparing to import data…',
  bakery2b: 'Bakery2B',
  company_profile: 'Company Profile',
  brand: 'Brand',
  site: 'Site',
  profile_photo: 'Profile Photo (200x200)',
  company_style: 'Company Style',
  menu_navigation_color: 'Color for Menu Navigation',
  background: 'Background (800x1600)',
  available_future_days: 'Available Future Days',
  minimal_order_value: 'Minimal Order Value (in currency)',
  only_whole_numbers: 'Only whole numbers in orders',
  multiple_orders_allowed: 'User is allowed to make more than 1 order per day',
  allow_zero_orders: 'Allow zero orders',
  show_total_column_delivery_note: 'Show Total Column In Delivery Note Section table',
  email_for_order_notifications: 'Email for order notifications',
  email_for_order_notifications_maxLen: 'Maximum characters number - 1000',
  use_new_site_version:
    'Use new site version (redirect users from bakery2b.com to new.bakery2b.com)',
  client_other: 'Clients',
  settings: 'Settings',
  import_processing_rows: 'Importing your data, please wait…',
  import_validating_data: 'Checking for errors…',
  import_applying_changes: 'Finalizing the import…',
  subtitle_import_step_2:
    'Assign price categories from WaWiAssist to the corresponding categories in CashAssist, then click ‘Import’.',
  cashassist_price_categories: 'CashAssist price categories',
  wawiassist_price_categories: 'WaWiAssist price categories',
  import_mapping: 'Import mapping',
  article_import_title: 'Article import completed.',
  article_import_created: '{{count}} created',
  article_import_updated: '{{count}} updated',
  searching_for_duplicate_articles: 'Searching for duplicate articles…',
  scanning_articles_in_cashassist_and_wawiassist: 'Scanning articles in CashAssist and WawiAssist…',
  comparing_data_between_systems: 'Comparing data between systems…',
  checking_article_uniqueness: 'Checking article uniqueness…',
  finalizing_duplicate_search: 'Finalizing duplicate search…',
  ca_description: 'CashAssist Description',
  ca_number: 'CashAssist Number',
  duplicates_were_found: 'Duplicates were found',
  message_to_fix_article_numbers: 'To continue, please correct the following article numbers.',
  activate_ftp: 'Activate FTP',
  reimport_articles_from_ca: 'Reimport articles from CA',
  remote_path: 'Remote path',
  port: 'Port',
  host: 'Host',
  ftp_connection: 'FTP Connection',
  days_before_after_execution_date: 'Days before/after execution date',
  apply_footerText_to_all_print_forms: 'Apply footer text to all print forms',
  apply_letterhead_to_all_print_forms: 'Apply letterhead to all print forms',
  apply_logo_to_all_print_forms: 'Apply logo to all print forms',
  options: 'Options',
  company: companyEn,
  configuration: 'Configuration',
  general_tab: 'General',
  customer_tab: 'Customer',
  article_tab: 'Article',
  order_tab: 'Order',
  internet_orders_tab: 'Internet ordering',
  production_tab: 'Production',
  invoice_tab: 'Invoice',
  vat_tab: 'VAT',
  size: 'Size',
  imported_toolbox_corrections_files_directory: 'Imported Toolbox corrections files directory',
  toolbox_corrections_files_directory: 'Toolbox corrections files directory',
  reset_to_default: 'Reset to default',
  default_settings: 'Default settings',
  bank_accounts_tab: 'Bank account',
  post_tab: 'Post',
  financial_accounting_tab: 'Financial accounting',
  special_days_tab: 'Special days',
  writing_tab: 'Writing',
  client: 'Client',
  vat_normal: 'VAT normal',
  vat_reduced: 'VAT reduced',
  no_vat: 'No VAT',
  activate_commit: 'Activate commit',
  datev: 'Datev',
  abacus: 'Abacus',
  profile_name: 'Profile name',
  cash_discount_in: 'Cash discount in %',
  price_category: 'Price category',
  summary_report: 'Summary report',
  payment_slip_report: 'Payment slip report',
  actual_invoice_no: 'Current invoice No.',
  rounding_total_prices: "Total's price rounding",
  use_another_countries: 'Use another currencies',
  euro_rate: 'Euro rate',
  usd_rate: 'USD rate',
  production_groups_one: 'Production group',
  production_groups_other: 'Production groups',
  production_groups_settings: 'Production groups settings',
  shipping_points_one: 'Shipping point',
  shipping_points_other: 'Shipping points',
  shipping_points_settings: 'Shipping points settings',
  enable_datev_export: 'Enable Datev export',
  enable_xml_export: 'Enable XML export',
  configuration_saved: 'Configuration was successfully saved',
  configuration_not_saved: 'Error: Configuration not saved!',
  assign_customer_no_automatically: 'Assign customer No. automatically',
  part_of_customer_no: 'Part of the customer No.',
  ongoing_value: 'Ongoing value',
  show_liters_in_production_print_lists: 'Show liters in production print lists',
  can_close_orders_from_cashAssist: 'Can close orders from CashAssist',
  take_into_consideration_own_produced_articles_from_procurement_in_backing_list_reports:
    'Take into consideration own-produced articles from procurement in backing list reports',
  the_same_ean_code_may_be_assigned_to_several_articles:
    'The same EAN code may be assigned to several articles',
  show_shipping_points_in_articles: 'Show shipping points in articles',
  shipping_function_activated: 'Activate shipping function',
  vat_normal_rate: 'VAT normal rate',
  vat_reduced_rate: 'VAT reduced rate',
  vat_special_1: 'VAT special 1',
  vat_special_2: 'VAT special 2',
  vat_zero: 'VAT 0%',
  product_groups_settings: 'Product groups settings',
  product_groups_one: 'Product group',
  product_groups_other: 'Product groups',
  price_categories_settings: 'Price categories settings',
  actual_order_number: 'Current order No.',
  decimal_place_count: 'Number of decimal places',
  order_position_sorting_kind: 'Sort order positions by',
  kilo_amount_representation: 'Kilogram amount representation',
  is_use_price_category_ahead: 'If there is no price, use price category ahead',
  is_got_next_delivery_day: 'When capturing the order, position automatically to next delivery day',
  delivery_days: 'Delivery days',
  related_directories: 'Related directories',
  delivery_note_groups_settings: 'Delivery note groups settings',
  delivery_note_groups_one: 'Delivery note group',
  delivery_note_groups_other: 'Delivery note groups',
  article_list_settings: 'Article lists settings',
  article_list_one: 'Article list',
  article_list_other: 'Article lists',
  customer_lists_settings: 'Customer lists settings',
  customer_lists_one: 'Customer list',
  customer_lists_other: 'Customer lists',
  post_sectors_settings: 'Post sectors settings',
  post_sectors: 'Post sectors',
  post_sectors_one: 'Post sector',
  post_sectors_other: 'Post sectors',
  weight_up_to: 'Weight up to (g)',
  name: 'Name',
  customer_groups_settings: 'Customer groups settings',
  customer_groups_one: 'Customer group',
  customer_groups_other: 'Customer groups',
  text_blocks_settings: 'Text blocks settings',
  text_blocks_one: 'Text block',
  text_blocks_other: 'Text blocks',
  standard_order: 'Standard (Order)',
  standard_offer: 'Standard (Offer)',
  standard_invoice: 'Standard (Invoice)',
  text_block: 'Text block',
  company_name_in_reports: 'Company name on print lists',
  standard_besr: 'Standard BESR',
  standard_bank: 'Standard bank',
  besr_format: ' BESR format',
  operation_cost_center: 'Operation cost center',
  tourplans_settings: 'Tourplans settings',
  tourplans_one: 'Tourplan',
  tourplans_other: 'Tourplans',
  tourplan: 'Tourplan',
  marketing_groups_settings: 'Marketing groups settings',
  assortment_groups_one: 'Assortment group',
  assortment_groups_other: 'Assortment groups',
  assortment_groups_settings: 'Assortment groups settings',
  quantity_discounts_settings: 'Quantity discounts settings',
  quantity_discounts_one: 'Quantity discount',
  quantity_discounts_other: 'Quantity discounts',
  quantity_discount: 'Quantity discount',
  marketing_groups_one: 'Marketing group',
  marketing_groups_other: 'Marketing groups',
  price_categories_one: 'Price category',
  price_categories_other: 'Price categories',
  banks_settings: 'Banks settings',
  bank_settings: 'Bank settings',
  internal_bank_description: 'Internal bank description',
  section_bank: 'Bank',
  section_customer: 'Customer',
  zip_code: 'ZIP/Location',
  subscriber_num: 'ESR/BESR Subscriber-Nr.',
  qr_iban: 'QR-IBAN',
  customer_identification: 'Customer identification (max. 6 letters)',
  financial_accounting: 'Financial accounting bank account',
  first_name: 'Name 1',
  second_name: 'Name 2',
  street: 'Street',
  recipe_book: 'Book of receipts',
  invalid_member_num: 'Only numbers are allowed',
  invalid_qr_iban: 'The IBAN you entered is not a QR IBAN. ',
  qr_field_hint: 'This field is required to correctly generate the QR code on the QR payment slip.',
  cannot_delete_this_bank:
    'Unfortunately, you cannot delete this bank because it is defined as the default bank.',
  general_vat_system: 'General VAT system',
  from_invoice_amount: 'From amount (invoice)',
  reminder_text: 'Reminder text',
  reminder_texts_settings: 'Reminder texts settings',
  fixed_shipping_costs: 'Fixed shipping costs',
  shipping_costs_by_weight: 'Shipping costs by weight',
  shipping_cost: 'Shipping cost',
  report_header: 'Report header',
  banks: 'Banks',
  storage_locations_settings: 'Storage locations settings',
  storage_locations_one: 'Storage location',
  storage_locations_other: 'Storage locations',
  order_types_accounted_in_production_reports: 'Order types accounted in production reports',
  order_types: 'Order types',
  working_with_versions: 'Working with versions',
  import_tab: 'Import',
  mode: 'Mode',
  some_existing_records_will_be_overwrited:
    'Some existing records will be overwrited with new imported records',
  there_are_some_duplicates_in_import_data: 'There are some duplicates in import data',
  some_existing_record_will_be_overwrited:
    'Some existing record will be overwrited with new imported record',
  duplicate_in_import_data: 'Duplicate in import data',
  import_successful:
    'Import successful.\nInserted records: {{recordsInserted}}.\nUpdated records:{{recordsUpdated}}.',
  special_prices_import: 'Special prices',
  special_prices_import_successful:
    'Special prices import successful.\nInserted periods: {{recordsInserted}}.\nUpdated periods: {{recordsUpdated}}.\nSkipped rows: {{recordsSkipped}}.',
  special_prices_periods: 'Periods: {{selected}} of {{total}} selected ({{articles}} articles)',
  special_prices_duplicate_periods:
    'The same period appears more than once. Only the last row will be imported.',
  special_prices_overlapping_periods:
    'Some periods overlap. The period with the later "Valid from" date applies.',
  special_prices_unknown_article: 'Article number does not exist',
  special_prices_unknown_articles:
    '{{total}} row(s) with an unknown article number will be skipped. A price import never creates articles.',
  special_prices_unmapped_columns:
    'These price columns matched no price category and will be ignored: {{columns}}',
  special_prices_mode_merge: 'Merge periods',
  special_prices_mode_replace: 'Replace table per article',
  special_prices_replace_confirmation:
    'Every existing special price period of {{articles}} article(s) will be deleted and replaced by the rows from the file. Periods not present in the file will be lost.',
  ai_processing_your_file: 'HS-Soft AI processing your file...',
  production_printers_settings: 'Production printers settings',
  production_printers: 'Production printers',
  print_list_groups_settings: 'Print list groups settings',
  print_list_groups_one: 'Print list group',
  print_list_groups_other: 'Print list groups',
  reportConfigurationTab: 'Report configuration',
  print_form_type: 'Print form type',
  print_form_article_pricelist: 'Article price list',
  print_form_offer: 'Offer',
  print_form_delivery_note_a4: 'Delivery note A4',
  print_form_delivery_note_a5: 'Delivery note A5',
  print_form_invoice: 'Invoice',
  print_form_payment_slip: 'Payment slip',
  print_form_debt_reminder: 'Debt reminder',
  no_preview_article_not_exist: 'Report preview unavailable. Please create an <a>article</a> first',
  no_preview_offer_not_exist: 'Report preview unavailable. Please create an <a>offer</a> first',
  no_preview_order_not_exist: 'Report preview unavailable. Please create an <a>order</a> first',
  no_preview_invoice_not_exist: 'Report preview unavailable. Please create an <a>invoice</a> first',
  page_margins: 'Page margins',
  page_background_image: 'Page background picture',
  letterhead: 'Letterhead',
  custom_text: 'Custom text',
  customer_address: 'Customer address',
  delivery_address: 'Delivery address',
  invoice_address: 'Invoice address',
  invoice_address_on_2_plus_pages: 'Invoice address on 2+ pages',
  delete_reason: 'Delete reason',
  bank_information: 'Bank information',
  phone_number: 'Phone number',
  picture: 'Picture',
  logo: 'Logo',
  logo_on_1_page: 'Logo on 1 page',
  logo_on_2_plus_pages: 'Logo on 2+ pages',
  company_vat_no: 'Company VAT (UID) No.',
  image_in_footer: 'Image in footer',
  footerText: 'Text in footer',
  printed_at_in_footer: 'Printed at (footer)',
  page_numbering_in_footer: 'Page numbering (footer)',
  created_by_in_footer: 'Created by (footer)',
  visible: 'Visible',
  cm_brackets: '(cm)',
  left_margin: 'Left',
  top_margin: 'Top',
  bottom_margin: 'Bottom',
  left: 'Left',
  top: 'Top',
  height: 'Height',
  width: 'Width',
  automation: 'Automation',
  automation_task: 'Automation',
  automation_tasks: 'Automations',
  create_automation_task: 'Create automation',
  delete_automation_task: 'Delete automation',
  expand_preview: 'Expand preview',
  automation_type: 'Automation type',
  termination_orders_acceptance_hint:
    'The execution blocks placing and editing orders (bakery2b.com and CashAssist DirectAccess) by delivery date: scheduled right after midnight (e.g. 00:01), it blocks orders for that same day; scheduled during the day, it blocks orders for the following day.',
  termination_next_blocked_day: 'Next blocked day',
  last: 'Last',
  next: 'Next',
  active: 'Active',
  execution_timetable: 'Execution timetable',
  time: 'Start time',
  weekDay: 'Weekday',
  monthDay: 'Month day',
  month: 'Month',
  day: 'day',
  every: 'Every',
  in: 'in',
  at: 'at',
  ordinal_ending: 'th',
  ordinal_ending_1: 'st',
  ordinal_ending_2: 'nd',
  ordinal_ending_3: 'rd',
  files_export_directory: 'Files export directory',
  execute: 'Run',
  task_started: 'The task has started.',
  general_settings_for_all_print_forms: 'Apply to all print forms',
  apply_settings_for_all_print_forms_warning:
    'Some print forms already have a custom "{{field}}". Applying this will replace it.',
  special_dates_settings: 'Special dates settings',
  replacing_date: 'Replacing date',
  [C_Printed_Reports_Kind.BAKING_LISTS]: 'Baking lists',
  [C_Printed_Reports_Kind.CROSSTABLE_REPORTS]: 'Crosstable reports',
  [C_Printed_Reports_Kind.DELIVERY_NOTES_A4]: 'Delivery notes A4',
  [C_Printed_Reports_Kind.DELIVERY_NOTES_A5]: 'Delivery notes A5',
  [C_Printed_Reports_Kind.FORWARDING_LISTS]: 'Forwarding lists',
  [C_Printed_Reports_Kind.INVOICES]: 'Invoices',
  [C_Printed_Reports_Kind.INVOICE_PAYMENT_SLIP]: 'Invoice payment slip',
  [C_Printed_Reports_Kind.INVOICE_SUMMARY]: 'Invoice summary',
  [C_Printed_Reports_Kind.OFFERS]: 'Offers',
  export_environment: 'Export environment',
  use_tour_setting_for_every_order: 'Use tour setting for every order',
  view_all_edit: 'View all & edit',
  no_preview_offer_not_exist_sub:
    'Report preview unavailable. Please create an <a>offer</a> first for selected company',
  no_preview_order_not_exist_sub:
    'Report preview unavailable. Please create an <a>order</a> first for selected company',
  no_preview_invoice_not_exist_sub:
    'Report preview unavailable. Please create an <a>invoice</a> first for selected company',
  no_preview_customer_not_exist_sub:
    ' No <a>customer</a> is assigned to this company yet – no information available at the moment.',
  use_standard_text: 'Use standard text',
  email_text: 'Email text',
  edit_wawi_orders: 'Edit WaWi orders',
  one_time_customer_settings: 'One-time customer settings',
  default_profile_one_time_customers: 'Default profile for one-time customers',
});
